<template>
  <Hero
    :hero="hero"
    class="heroes-list-hero"
    :tabindex="tabindex"
    :class="classes"
    @click.native="selectHero()"
    @keyup.enter.native="selectHero()"
  />
</template>

<script>
import Hero from "./Hero";
import { mapGetters } from "vuex";

export default {
  name: "HeroesListHero",

  components: {
    Hero
  },

  props: {
    hero: {
      type: Object,
      required: true
    },
    access: Boolean
  },

  computed: {
    ...mapGetters("tournaments", ["match"]),
    isDisabled() {
      const { pick_ban_history: history } = this.match;
      return history && history.find(({ hero_id }) => hero_id === this.hero.id);
    },
    classes() {
      return {
        "is-disabled": this.isDisabled
      };
    },
    tabindex() {
      return this.isDisabled ? "-1" : "0";
    }
  },

  methods: {
    selectHero() {
      if (this.isDisabled) return;
      this.$emit("select", this.hero);
    }
  }
};
</script>

<style lang="scss">
.heroes-list-hero {
  &.is-disabled {
    pointer-events: none;
    filter: brightness(0.3);
  }
  &:hover {
    cursor: pointer;
    border-color: #1480b2;
  }
  &:active {
    box-shadow: 0 0 5px 0 #1480b2;
  }
}
</style>
